import type { Theme } from '@mui/material';
import { getSummarySegmentTextColor } from '../utils/orderItem/helpers';

export function historyLabelTextColor(
  theme: Theme,
  hex?: string | null
): string | undefined {
  const color = hex?.trim();
  if (!color) {
    return undefined;
  }
  return getSummarySegmentTextColor(theme, color);
}
